export default "__VITE_ASSET__CV680jH___"